import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullView = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 0h6v6h-2V3.5L10.4 7 9 5.7 12.7 2H10V0zM7 10.4L5.8 9 2 12.7V10H0v6h6v-2H3.5L7 10.4zM9 3H3v6H2V2h7v1zM7 14v-1h6V7h1v7H7z" })
});
export default SvgFullView;
